import { React } from 'jimu-core';
import { GlobalStyle } from '../../../__emotion__';
import { getFontFaces } from '../../../base/assets/fonts';
export const defaultFonts = [
    'Avenir Next',
    'Calibri',
    'PmingLiu',
    'Impact',
    'Georgia',
    'Arial',
    'Times New Roman',
    'SimHei',
    'Microsoft YaHei'
];
const fontStyle = getFontFaces();
const CacheFonts = {};
export const loadFontStyleSheet = (font) => {
    const { name, url } = font;
    if (CacheFonts[name])
        return Promise.resolve(CacheFonts[name]);
    return fetch(url).then(() => {
        CacheFonts[name] = name;
        return name;
    });
};
export const FontLoader = (props) => {
    const { theme } = props;
    const customFonts = theme.typography.customFonts;
    React.useEffect(() => {
        const promises = customFonts === null || customFonts === void 0 ? void 0 : customFonts.map(customFont => loadFontStyleSheet(customFont));
        if (promises === null || promises === void 0 ? void 0 : promises.length) {
            Promise.all(promises).then(() => null).catch(error => {
                console.log(error);
            });
        }
    }, [customFonts]);
    return (React.createElement(GlobalStyle, { theme: theme, styles: fontStyle }));
};
